<template>
    <template v-if="verticalVersion">
        <div class="p-relative light-light-background max-size">
            <div class="image-container app-image center-x px-5 py-3">
                <img
                    v-if="information.image && information.image.url"
                    alt=""
                    :src="information.image.url"
                    class="information-image"
                />
                <ion-icon
                    v-else-if="hasProduct || props.itemPlaceholder" src="/assets/icon/item.svg"
                    class="coral-coral-color information-image"
                    style="height: 100%; width: 100%"
                />
                <ion-icon
                    v-else :icon="newspaperOutline" class="coral-coral-color information-image"
                    style="height: 100%; width: 100%"
                />
            </div>

            <!-- <template v-if="information.kind !== INFORMATION_TYPE.NEWS && suppliers.length">
                <product-availability
                    :has-product="hasProduct"
                    :suppliers="suppliers"
                    :product-suppliers="productSuppliers"
                    :audience-type="information.audience.type"
                    style="padding: 5px;"
                />
            </template> -->

            <ion-grid class="light-light-background purple-purple-color">
                <ion-row>
                    <ion-col>
                        <span class="fw-b fs-larger">
                            {{ information.title }}
                        </span>
                    </ion-col>
                </ion-row>

                <ion-row class="mt-2" v-if="information.body">
                    <ion-col>
                        <div v-html="information.body"/>
                    </ion-col>
                </ion-row>

                <flexible-product-interface
                    v-if="suppliers.length && product && information.kind === INFORMATION_TYPE.PROMOTION && information.promotionType === PROMOTION_TYPE.BONUS_FLEXIBLE"
                    :information="information"
                    :audience="suppliers"
                    @add-package="$emit('addPackage', $event)"
                />

                <news-modal-product-interface
                    v-else-if="suppliers.length && product && hasProduct && (information.kind === INFORMATION_TYPE.PRODUCT_PRESENTATION || information.kind === INFORMATION_TYPE.PROMOTION)"
                    v-model="product"
                    v-model:amount="amount"
                    :information="information"
                    :cart="cart"
                    @add="$emit('add',{product: product, amount})"
                />

                <ion-row>
                    <ion-col class="center">
                        <button-base
                            v-if="information.file"
                            @click="downloadFileApi({ fileRoute: information.file.url, fileName: information.file.name })"
                        >
                            <!--TODO: ADD translation-->
                            Download
                        </button-base>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
    </template>

    <template v-else-if="information">
        <ion-grid
            class="purple-purple-color d-flex flex-d-c flex-grow-1 max-size"
            :style="!isApp() ? 'padding-inline: 4.25rem;' : ''"
        >
            <ion-row class="max-height">
                <ion-col class="center max-height-100">
                    <img
                        v-if="information.image && information.image.url"
                        alt=""
                        :src="information.image.url"
                        class="information-image"
                    />
                    <ion-icon
                        v-else-if="hasProduct || props.itemPlaceholder" src="/assets/icon/item.svg"
                        class="coral-coral-color information-image"
                        style="height: 100%; width: 100%"
                    />
                    <ion-icon
                        v-else :icon="newspaperOutline" class="coral-coral-color information-image"
                        style="height: 100%; width: 100%"
                    />
                </ion-col>

                <ion-col class="max-height-100 overflow-auto center-y-safe">
                    <div :class="{'center flex-d-c max-width': hasProduct }">
                        <div :class="{'max-width width-max-400': hasProduct }">
                            <!-- <template v-if="information.kind !== INFORMATION_TYPE.NEWS && suppliers.length">
                                <product-availability
                                    :has-product="hasProduct"
                                    :suppliers="suppliers"
                                    :product-suppliers="productSuppliers"
                                    :audience-type="information.audience.type"
                                    style="padding: 5px"
                                />
                            </template> -->

                            <ion-row>
                                <ion-col>
                                <span class="octo-gradient-purple-color fw-b fs-larger">
                                    {{ information.title }}
                                </span>
                                </ion-col>
                            </ion-row>

                            <ion-row>
                                <ion-col>
                                    <div
                                        v-html="information.body"
                                    />
                                </ion-col>
                            </ion-row>

                            <flexible-product-interface
                                v-if="suppliers.length && product && information.kind === INFORMATION_TYPE.PROMOTION && information.promotionType === PROMOTION_TYPE.BONUS_FLEXIBLE"
                                :information="information"
                                :audience="suppliers"
                                @add-package="$emit('addPackage', $event)"
                            />

                            <news-modal-product-interface
                                v-else-if="suppliers.length && product && hasProduct && (information.kind === INFORMATION_TYPE.PRODUCT_PRESENTATION || information.kind === INFORMATION_TYPE.PROMOTION)"
                                v-model="product"
                                v-model:amount="amount"
                                :information="information"
                                :cart="cart"
                                @add="$emit('add',{product: product, amount})"
                            />

                            <ion-row>
                                <ion-col class="center">
                                    <button-base
                                        v-if="information.file"
                                        @click="downloadFileApi({ fileRoute: information.file.url, fileName: information.file.name })"
                                    >
                                        <!--TODO: ADD translation-->
                                        Download
                                    </button-base>
                                </ion-col>
                            </ion-row>
                        </div>
                    </div>
                </ion-col>
            </ion-row>
        </ion-grid>
    </template>
</template>

<script setup lang="ts">
import { IonCol, IonGrid, IonIcon, IonRow, isPlatform } from "@ionic/vue";
import { newspaperOutline } from "ionicons/icons";
import { isApp, isNativeApp } from "@/functions/enviroment";
import ButtonBase from "@/components/button/ButtonBase.vue";
import { InformationInterfaceProps } from "@/types/props/modal";
import { computed, onBeforeUnmount, ref, watch } from "vue";
import { downloadFileApi } from "@/api-connectors/file";
import NewsModalProductInterface from "@/components/modal/NewsModalProductInterface.vue";
import FlexibleProductInterface from "@/components/modal/FlexibleProductInterface.vue";
import { ProductMaster, Supplier } from "@/types/supplier";
import { InformationInterfaceEmits } from "@/types/emits/component";
import { AUDIENCE_TYPE, INFORMATION_TYPE, PROMOTION_TYPE } from "@/types/enum/notification";
import { useSupplierStore } from "@/stores/suppliers";
import ProductAvailability from "@/components/various/ProductAvailability.vue";

const props = defineProps<InformationInterfaceProps>()
defineEmits<InformationInterfaceEmits>()

const supplierStore = useSupplierStore()

const evaluateAmount = (): number => {
    if (!props.information || !availableProducts.value?.length) return 1

    const firstProduct = availableProducts.value[0]

    if (!firstProduct) return 1

    return (firstProduct.recommendedAmount ?? firstProduct.stepAmount) ?? 1
}

// remove product variant from the selection if there are no harmonized product by any supplier of this location
const availableProducts = computed<ProductMaster[] | undefined>(() => props.information?.products.filter((i: ProductMaster) => i.availableBy?.length))

const amount = ref<number>(evaluateAmount())
const product = ref<ProductMaster | undefined>(availableProducts.value?.length ? availableProducts.value[0] : undefined)

const hasProduct = computed<boolean>(() => props.information?.products?.length > 0)

const suppliers = computed<Supplier[]>(() => {
    if (!props.information) return []

    if (props.information.audience.type === AUDIENCE_TYPE.ALL) return supplierStore.allSuppliers

    const informationSuppliers: Supplier[] = []
    for (const supplierId of props.information.audience.participatingSupplierIds) {
        const participatingSupplier = supplierStore.supplierById(supplierId)
        if (!participatingSupplier) continue

        // Remove suppliers without harmonised products from the 'Available by' section
        // Attention! Remove only from promotions! Product suggestions should still include suppliers without harmonised products.
		const availableProductsBySuppliers = new Set(availableProducts.value?.map((i) => i.availableBy).flat());
		if (props.information.kind === INFORMATION_TYPE.PROMOTION && !availableProductsBySuppliers.has(participatingSupplier.id)) continue;
        
        informationSuppliers.push(participatingSupplier)
    }

    return informationSuppliers
})

const productSuppliers = computed<Supplier[]>(() => {
    if (!hasProduct.value) return []

    if (!product.value?.availableBy) return []

    const informationSuppliers: Supplier[] = []
    for (const supplierId of product.value.availableBy) {
        const participatingSupplier = supplierStore.supplierById(supplierId)
        if (!participatingSupplier) continue
        informationSuppliers.push(participatingSupplier)
    }
    return informationSuppliers
})

watch(() => props.information.id, () => {
    product.value = availableProducts.value?.length ? availableProducts.value[0] : undefined
    amount.value = evaluateAmount()
})

/* BUG-FIX: KeyboardResize issue on iOS */

import { Keyboard, KeyboardResize } from '@capacitor/keyboard';

let keyboardShowListener: any;

async function setupKeyboardListener() {
    Keyboard.setResizeMode({ mode: KeyboardResize.Body });
    keyboardShowListener = await Keyboard.addListener('keyboardDidShow', () => {
        // Scroll the active element into view
        document.activeElement?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
}

if (isNativeApp && isPlatform('ios')) setupKeyboardListener()

onBeforeUnmount(() => {
    if (isNativeApp && isPlatform('ios')) {
        keyboardShowListener.remove();
        Keyboard.setResizeMode({ mode: KeyboardResize.Native });
    }
})

const verticalVersion = ref<boolean>(isApp() && !window.matchMedia("(orientation: landscape)").matches)
window.addEventListener('orientationchange', () => verticalVersion.value = isApp() && window.matchMedia("(orientation: portrait)").matches)
window.addEventListener('resize', () => verticalVersion.value = isApp() && window.matchMedia("(orientation: portrait)").matches)
</script>

<style scoped>
.image-container.app-image {
    height: Max(300px, 100%);
    width: 100%;
    max-height: 300px;
}

.information-image {
    height: 100%;
    max-height: Min(500px, 100%);
    object-fit: cover;
}
</style>
